<template>
  <UserProfile />
</template>
<script setup>
import UserProfile from '@/components/hijo3/UserProfile.vue';
</script> 